import React from "react";
import "../style/About.css";
import hero from "../../assets/hero.png";
import aboutImg from "../../assets/plaindelivery.png";
import ctaImg from "../../assets/AboutIMG.png";

const About = () => {
  return (
    <div className="about-page">

      {/* HERO */}
      <section
        className="about-hero"
        style={{ backgroundImage: `url(${hero})` }}
      >
        <div className="overlay">
          <h1>About PFA Logistics Pvt. Ltd.</h1>
          <p>
            PFA Logistics Pvt. Ltd. is a trusted logistics and supply chain
            solutions provider, committed to delivering reliable, efficient,
            and cost-effective transportation services across India and worldwide.
          </p>
        </div>
      </section>

      {/* ABOUT */}
      <section className="about-section">
        <div className="about-content">
          <div className="text">
            <h2>Who We Are</h2>
            <p>
              We are more than a logistics company—we are your logistics partner.
              Our experienced professionals understand the complexities of
              domestic and international transportation and provide customized
              solutions tailored to your needs.
            </p>
            <p>
              From small consignments to large-scale cargo movements, PFA Logistics
              handles every shipment with care, precision, and transparency.
            </p>

            <div className="features">
              <div>🌍 Global Logistics Network</div>
              <div>✈️ Air Freight Services</div>
              <div>🚛 Road Transportation</div>
              <div>📦 End-to-End Cargo Handling</div>
            </div>
          </div>

          <div className="image">
            <img src={aboutImg} alt="PFA Logistics Cargo" />
          </div>
        </div>
      </section>

      {/* MISSION & VISION */}
      <section className="mission-vision">
        <div className="mv-box">
          <h3>Our Mission</h3>
          <p>
            To deliver world-class logistics solutions that empower businesses
            to grow by ensuring speed, safety, and reliability in every shipment.
          </p>
        </div>

        <div className="mv-box">
          <h3>Our Vision</h3>
          <p>
            To become a leading logistics company recognized for innovation,
            trust, and excellence in supply chain management.
          </p>
        </div>
      </section>

      {/* CTA */}
      <section
        className="cta-section"
        style={{ backgroundImage: `url(${ctaImg})` }}
      >
        <div className="cta-overlay">
          <h2>Let’s Move Your Business Forward</h2>
          <p>
            Partner with PFA Logistics Pvt. Ltd. and experience logistics that
            move faster, smarter, and safer.
          </p>
          <button>Get a Free Quote</button>
        </div>
      </section>

    </div>
  );
};

export default About;
